import { type Meter } from '#packages/data-collection/models/audit-background-form/categories/general';

export const MeterTypeLabel: Record<Meter['type'], string> = {
  electricity: 'Electricity',
  natural_gas: 'Natural Gas',
  water: 'Water',
  other: 'Other',
} as const;

export const CanadaProvinces = [
  'Alberta',
  'British Columbia',
  'Manitoba',
  'New Brunswick',
  'Newfoundland and Labrador',
  'Nova Scotia',
  'Ontario',
  'Prince Edward Island',
  'Quebec',
  'Saskatchewan',
  'Northwest Territories',
  'Nunavut',
  'Yukon',
];
